import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { addAlert } from '../../../utils/alerts';
import { getDateDifference, getIsNextPaymentDateToday } from '../../../utils/dateTime';
import { useTracker } from '../../../utils/usageTracker';
import { useEditNextPaymentDateMutation } from './useEditNextPaymentDateMutation';
import { jsx as _jsx } from "react/jsx-runtime";
export const useEditNextPaymentDate = (objectId, close) => {
  const {
    trackBillingDateChange
  } = useTracker();
  const handleError = useCallback(() => {
    addAlert({
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "subscriptions.EditNextPaymentDateModal.errorChangingTitle"
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "subscriptions.EditNextPaymentDateModal.errorChangingMessage"
      }),
      type: 'danger'
    });
    close();
  }, [close]);
  const [onSubmit, {
    loading
  }] = useEditNextPaymentDateMutation(handleError, close);
  const submitUpdateBillingDate = useCallback(({
    nextPaymentDueDate,
    subscriptionInvoiceId,
    proposedPaymentDueAt
  }) => {
    const isNextPaymentDateToday = getIsNextPaymentDateToday(nextPaymentDueDate);
    if (!isNextPaymentDateToday) {
      const delta = getDateDifference(Date.now(), Number(nextPaymentDueDate));
      const dateRange = getDateDifference(Number(nextPaymentDueDate), proposedPaymentDueAt);
      onSubmit({
        variables: {
          input: {
            objectId,
            upcomingSubscriptionInvoiceId: subscriptionInvoiceId,
            proposedPaymentDueAt
          }
        }
      }).catch(handleError);
      trackBillingDateChange({
        subType: 'edit-next-payment-date',
        action: 'updateSubscriptionEditNextPaymentDateModalSubmitted',
        delta,
        dateRange
      });
    } else {
      handleError();
    }
  }, [onSubmit, handleError, trackBillingDateChange, objectId]);
  return {
    submitUpdateBillingDate,
    submitLoading: loading
  };
};